/**
 * Слова и места состояния эфира - без React и без запросов: их читают и
 * сценарии (`e2e/class-live.spec.ts`), и ворота `UI-14`. Хук - в
 * `liveState.ts`. Зачем всё это - там же.
 */
export type LiveKind = 'tiktok' | 'simulator' | 'none';

export interface LiveWords {
  /** Статус в «Подключении». */
  status: string;
  /** Хвост подсказок счётчиков: «за эфир», «за сессию симулятора». */
  span: string;
  /** Имя ленты событий для чтеца. */
  feed: string;
}

export const LIVE_WORDS: Record<LiveKind, LiveWords> = {
  tiktok: { status: 'В эфире', span: 'за эфир', feed: 'Лента эфира' },
  simulator: { status: 'Симулятор', span: 'за сессию симулятора', feed: 'Лента симулятора' },
  none: { status: 'Готово', span: 'за эфир', feed: 'Лента эфира' },
};

/**
 * Места, где продукт называет состояние эфира. Ключ - `data-live-place`.
 *
 * История и аналитика - про настоящие эфиры: симулятор туда не попадает
 * вовсе, и ворота проверяют именно это, а не слова.
 */
export const LIVE_PLACES = {
  'connection-status': 'статус в «Подключении»',
  'stat-strip': 'счётчики правой колонки и их подсказки',
  'chat-feed': 'лента событий правой колонки',
  quota: 'остаток эфира в шапке',
  history: 'история эфиров',
  analytics: 'аналитика эфиров',
} as const;

export type LivePlace = keyof typeof LIVE_PLACES;
